// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","brightGreen":"#22d28f","footerGrey":"#c0c0c0","borderGrey":"#d5dfdf","brightGreenLt":"#4cdaa4","brightGreenDk":"#19ab73","customWhite":"#ffffff","customGreyLt":"#f2f2f2","container":"_1PytRs6_5l_c6uelbOT31i","pressed":"_2jNW1vqGNkGhKnsU3_w-Ym","disabled":"ButOgMvoIImv7_GECq4gE"};


//////////////////
// WEBPACK FOOTER
// ./src/common/primary-button/PrimaryButton.css
// module id = 447
// module chunks = 0 1 2